import axiosApi from '../../kits/axiosApi';
import { message } from 'ant-design-vue';

function unwrapBiz(res) {
    // { code: 0, data: { code, msg, data } }
    return (res && res.data && res.data.data) || {};
}

function persistSession(commit, session) {
    const token = session.access_token || session.token || '';
    window.localStorage.setItem('token', token);
    window.localStorage.setItem('sid', session.sid || '');
    window.localStorage.setItem('sname', session.sname || '');
    window.localStorage.setItem('slogo', session.slogo || '');
    window.localStorage.setItem('timezone', session.timezone || '');
    window.localStorage.setItem('country', session.country || '');
    window.localStorage.setItem('user_name', session.user_name || '');
    window.localStorage.setItem('role', session.role || 'admin');

    commit(
        'app/APP_SET_GLOBAL_DAT',
        {
            data: {
                sid: session.sid || '',
                role: session.role || 'admin',
                sname: session.sname || '',
                slogo: session.slogo || '',
                token,
                timezone: session.timezone || '',
                user_name: session.user_name || '',
                country: session.country || ''
            }
        },
        { root: true }
    );
}

const state = {
    register_prefill: null
};

const getters = {};

const actions = {
    /**
     * POST /api/sso/verify
     * @returns {Promise<{code, msg, data}>}
     */
    async verify_sso_token({ commit, rootState }, { token }) {
        const aj_host = rootState.debug ? 'http://127.0.0.1:5551' : '';
        const res = await axiosApi.post(aj_host + '/api/sso/verify', { token });
        const biz = unwrapBiz(res);

        if (biz.code === 100000 && biz.data) {
            persistSession(commit, biz.data);
        } else if (biz.code === 100001 && biz.data) {
            commit('SSO_SET_REGISTER_PREFILL', biz.data);
            try {
                window.sessionStorage.setItem(
                    'sso_register_prefill',
                    JSON.stringify(biz.data)
                );
            } catch (e) {
                /* ignore */
            }
        } else if (biz.msg) {
            message.error(biz.msg);
        }

        return biz;
    },

    /**
     * POST /api/merchant/register
     */
    async register_merchant({ commit, rootState }, payload) {
        const aj_host = rootState.debug ? 'http://127.0.0.1:5551' : '';
        const res = await axiosApi.post(aj_host + '/api/merchant/register', payload);
        const biz = unwrapBiz(res);

        if (biz.code === 100000 && biz.data) {
            persistSession(commit, biz.data);
            commit('SSO_SET_REGISTER_PREFILL', null);
            try {
                window.sessionStorage.removeItem('sso_register_prefill');
            } catch (e) {
                /* ignore */
            }
            message.success(biz.msg || 'Registration successful');
        } else if (biz.msg) {
            message.error(biz.msg);
        }

        return biz;
    }
};

const mutations = {
    SSO_SET_REGISTER_PREFILL(state, data) {
        state.register_prefill = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
